import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { PRICING_PATH_OPTIONS } from "./constants"
import type { PricingFormValues } from "./schemas"
import type { PricingPath } from "./types"

import { FormRadioGroup } from "@/components/UiKit"

interface PricingPathRadioProps {
  productId: number
  onChange: (value: PricingPath) => void
}

export const PricingPathRadio: FC<PricingPathRadioProps> = ({ productId, onChange }) => {
  const { control } = useFormContext<PricingFormValues>()

  return (
    <FormRadioGroup
      control={control}
      name='path'
      options={PRICING_PATH_OPTIONS}
      onChange={onChange}
      row
      data-testid={`sales.product-pricing-form.path-radio-${productId}`}
    />
  )
}
